import { defineMessages } from "react-intl";

import { node as alcohol } from "src/modules/htx/forms/risks/alcohol";
import { node as mentalHealthReview } from "src/modules/htx/forms/risks/mentalHealthReview";
import { node as smoking } from "src/modules/htx/forms/risks/smoking";
import { node as socialWorkerReview } from "src/modules/htx/forms/risks/socialWorkerReview";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.risks",
		defaultMessage: "Kockázati tényezők"
	}
});

export const node: ParentNode = {
	id: "risks",
	value: { type: "wizard", title: messages.title },
	children: [smoking, alcohol, socialWorkerReview, mentalHealthReview]
};
